// Header.js
import React from 'react';
import Team_img from './Assets/img1.jpg';
import TeamMemberCard from './TeamMemberCard';

const Header = () => {
  return (
    <div>
      <div>
      <p className="mainteam-sep-head mainteam-sep-head-text">Meet Our Team</p>
      <p className="mainteam-sep-sub-head-text">
        Just take a look - each member of the team is watching your every gesture and will hear your every whisper.
      </p>
      
      </div>
      
      
    </div>
    
    
    );
}

export default Header;
